import * as React from 'react';
import Card from '@mui/material/Card';
import Icn from './Icn';
import IconBtn from './IconBtn';
import { colors } from '../maps/colors';


export default function InstallerClientCard(props) {
    return (
        <Card data-id={props._id} onClick={props.onClick} sx={{ width: '100%', marginBottom: '5px', background: props.selected ? colors.LIGHT_GREEN+"50" : 'white' }}>
            <div style={{ padding: 5 }}>
                <Icn style={{ position: 'relative', top: 4 }}>user</Icn> <span style={{ fontSize: 18, fontWeight: 500 }}>{props.name}</span>
            </div>
            <div style={{ padding: 5 }}>
                <IconBtn customtheme="small-gray" size="small" onClick={props.onEdit}>edit</IconBtn>
                <IconBtn customtheme="small-gray" size="small" style={{ marginLeft: 5 }}>delete</IconBtn>
            </div>
        </Card>
    );
}